import React from 'react'
import { connect } from 'react-redux'

import LinePlaneFlyIcon from 'components/Luxkit/Icons/line/LinePlaneFlyIcon'
import { getDefaultAirportCode } from 'selectors/flightsSelectors'
import {
  OFFER_TYPE_HOTEL,
  OFFER_TYPE_TOUR,
} from 'constants/offer'
import CaptionTextBlock from 'components/Luxkit/TextBlocks/CaptionTextBlock'
import HotelPlusFlightsFrom from 'components/Common/HotelPlusFlightsFrom'

interface Props {
  offer: App.Offer | App.OfferSummary;
  flightOrigin?: string;
  className?: string;
}

function FrontPageTileFlightPricing(props: Props) {
  const {
    offer,
    flightOrigin,
    className,
  } = props

  const {
    flightCacheDisabled,
    lowestPricePackage,
    type,
    offerFlightsEnabled,
  } = offer

  const flightCacheOn = !flightCacheDisabled && offer.flightPrices[flightOrigin || '']

  if (flightCacheOn && type !== OFFER_TYPE_TOUR) {
    const lowestPkgPrice = lowestPricePackage?.price ?? 0
    const lowestPkgMemberPrice = lowestPricePackage?.memberPrice ?? 0
    const pkgPrice = type === OFFER_TYPE_HOTEL && lowestPkgMemberPrice > 0 ? lowestPkgMemberPrice : lowestPkgPrice
    const price = pkgPrice + offer.flightPrices[flightOrigin || '']

    return <HotelPlusFlightsFrom price={price} forTwoAdults />
  }

  const isFlightsEnabledWithTours = type === OFFER_TYPE_TOUR && offerFlightsEnabled

  return <CaptionTextBlock
    className={className}
    variant="medium"
    wrap="pre-wrap"
    startIcon={<LinePlaneFlyIcon />}
  >
    {isFlightsEnabledWithTours ? 'Tour' : 'Hotel'} + flights package available
  </CaptionTextBlock>
}

function mapStateToProps(state: App.State) {
  return {
    flightOrigin: getDefaultAirportCode(state),
  }
}

export default connect(mapStateToProps)(FrontPageTileFlightPricing)
